// Module
var code = `<div class="datepicker input-group input-append"> <span class="input-group-addon add-on"> <i class="fa fa-calendar"></i> </span> <input type="text" class="form-control marginless" ng-disabled="ngDisabled" autocomplete="off" aria-autocomplete="none"/> </div> `;
// Exports
var _module_exports =code;;
var path = '/views/components/datepicker.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;